import User from "@repositories/user";
import { useQuery } from "react-query";
import { User as TUser } from "@ts-types/generated";
import { API_ENDPOINTS } from "@utils/api/endpoints";
import { getAuthCredentials } from "@utils/auth-utils";

export const fetchMe = async () => {
  const { token } = getAuthCredentials();
  const { data } = token ? await User.find(API_ENDPOINTS.ME) : { data: null };
  return data;
};

export const useMeQuery = () => {
  return useQuery<TUser, Error>([API_ENDPOINTS.ME], () => fetchMe(), { staleTime: 60 * 1000 });
};
